import theme from 'antd/lib/theme';

const { useToken } = theme;

export default function useTheme() {
	const { token } = useToken();

	return {
		borderRadius: token.borderRadius,
		colorBgContainerDisabled: token.colorBgContainerDisabled,
		colorIcon: token.colorIcon,
		colorSuccess: token.colorSuccess,
		colorError: token.colorError,
		colorWarning: token.colorWarning,
		colorLink: token.colorLink,
		colorLinkActive: token.colorLinkActive,
		colorBgContainer: token.colorBgContainer,
		colorBgElevated: token.colorBgElevated,
		colorBgLayout: token.colorBgLayout,
		colorTextLabel: token.colorTextLabel,
		colorBorder: token.colorBorder,
		colorBorderSecondary: token.colorBorderSecondary,
		colorFillSecondary: token.colorFillSecondary,
		colorFillTertiary: token.colorFillTertiary,
		colorFillQuaternary: token.colorFillQuaternary,
		colorTextDescription: token.colorTextDescription,
		colorPrimary: token.colorPrimary,
		colorPrimaryBg: token.colorPrimaryBg,
		colorPrimaryBgHover: token.colorPrimaryBgHover,
		colorPrimaryBorder: token.colorPrimaryBorder,
		colorPrimaryBorderHover: token.colorPrimaryBorderHover,
		colorText: token.colorText,
		colorTextBase: token.colorTextBase,
		colorTextDisabled: token.colorTextDisabled,
		colorTextQuaternary: token.colorTextQuaternary,
		colorTextLightSolid: token.colorTextLightSolid,
		controlItemBgHover: token.controlItemBgHover, // Couleur de fond dans les listes au hover
		marginXL: token.marginXL,
		marginXXL: token.marginXXL,
		marginLG: token.marginLG,
		marginMD: token.marginMD,
		marginSM: token.marginSM,
		marginXS: token.marginXS,
		marginXXS: token.marginXXS,
		sizeSM: token.sizeSM,
		fontSize: token.fontSize,
		fontSizeHeading1: token.fontSizeHeading1,
		fontSizeHeading2: token.fontSizeHeading2,
		fontSizeHeading3: token.fontSizeHeading3,
		fontSizeHeading4: token.fontSizeHeading4,
		fontSizeHeading5: token.fontSizeHeading5,
		Pagination: token.Pagination,
	};
}
